import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import renderInlineSvg from '~/utils/renderInlineSvg';
import {notificationCloseIcon} from '~/constants/InlineSvgs';
import {Link} from '@customink/pigment-react';

import './index.scss';

const propTypes = {
  children: PropTypes.node,
  closeLink: PropTypes.string,
  dismiss: PropTypes.func,
  title: PropTypes.node,
  type: PropTypes.oneOf(['INFO', 'SUCCESS', 'ERROR', 'INKY', 'PROMPT', 'SAVE'])
};

export default class Notification extends Component {
  static displayName = 'Notification';
  static propTypes = propTypes;

  static defaultProps = {
    type: 'INFO'
  };

  handleClose = () => {
    this.props.dismiss && this.props.dismiss();
  };

  handleMouseDown = evt => {
    evt.stopPropagation();
  };

  render() {
    const classes = classnames('ndx-cta1', 'ndx-Notification', {
      'ndx-Notification--success': this.props.type === 'SUCCESS',
      'ndx-Notification--inky': this.props.type === 'INKY',
      'ndx-Notification--prompt': this.props.type === 'PROMPT'
    });

    return (
      <div className={classes} onMouseDown={this.handleMouseDown}>
        {this.props.dismiss && !this.props.closeLink && (
          <div
            className="ndx-Notification-close"
            dangerouslySetInnerHTML={renderInlineSvg(notificationCloseIcon)}
            onClick={this.handleClose}
          />
        )}
        {this.props.dismiss && this.props.closeLink && (
          <Link
            className="ndx-Notification-close"
            dangerouslySetInnerHTML={renderInlineSvg(notificationCloseIcon)}
            onClick={this.handleClose}
            href={this.props.closeLink}
          />
        )}
        {this.props.type === 'SUCCESS' ? (
          <div className="ndx-Notification-check" />
        ) : this.props.type === 'INKY' ? (
          <div className="ndx-Notification-inkyIcon" />
        ) : this.props.type === 'SAVE' ? (
          <div className="ndx-Notification-save" />
        ) : (
          <div className="ndx-Notification-alert" />
        )}
        {this.props.title && (
          <h4 className="ndx-Notification-title">{this.props.title}</h4>
        )}
        <div className="ndx-Notification-description">
          {this.props.children}
        </div>
      </div>
    );
  }
}
